import {
  alpha, darken, styled, Typography, TypographyProps,
} from '@mui/material';

interface StyledTypographyProps extends TypographyProps {
  color: string;
}
export const StyledTypography = styled((props: StyledTypographyProps) => {
  const { color, ...other } = props;
  return <Typography {...other} />;
})(({ color }) => ({
  margin: 0,
  fontSize: 10,
  lineHeight: '16px',
  padding: '2px 8px',
  borderRadius: 4,
  width: 'max-content',
  textTransform: 'uppercase',
  display: 'flex',
  gap: 4,
  alignItems: 'center',
  color: darken(color, 0.2),
  backgroundColor: alpha(color, 0.1),
  border: `1px solid ${color}`,
  fontWeight: 700,
}));

interface ContextTagProps {
  context: { color: string, text: string };
}

export default function ContextTag(props: ContextTagProps) {
  const { context } = props;
  return (
    <StyledTypography color={context.color}>
      {context.text}
    </StyledTypography>
  );
}
